import LogoFamilyIcon from '../../../../static/icons/logo/ic_family.svg';
import LogoRuleIcon from '../../../../static/icons/logo/ic_logo_rule.svg';
import LogoMilitaryIcon from '../../../../static/icons/logo/ic_military.svg';
import LogoStudentIcon from '../../../../static/icons/logo/ic_student.svg';
import LogoPandoraIcon from '../../../../static/icons/logo/logo_pandora.svg';
import LogoPlusIcon from '../../../../static/icons/logo/logo_pandora_plus.svg';
import LogoPremiumIcon from '../../../../static/icons/logo/logo_pandora_premium.svg';

export const tiers = Object.freeze({
  AD_SUPPORTED: 'AD_SUPPORTED',
  PANDORA_PLUS: 'PANDORA_PLUS',
  PANDORA_PREMIUM: 'PANDORA_PREMIUM',
  PANDORA_FAMILY: 'PREMIUM_FAMILY_PLAN',
});

export const discountTypes = Object.freeze({
  NONE: 'NONE',
  STUDENT: 'STUDENT',
  MILITARY: 'MILITARY',
});

export const planNames = Object.freeze({
  [tiers.AD_SUPPORTED]: {
    [discountTypes.NONE]: 'Pandora',
  },
  [tiers.PANDORA_PLUS]: {
    [discountTypes.NONE]: 'Pandora Plus',
  },
  [tiers.PANDORA_PREMIUM]: {
    [discountTypes.NONE]: 'Pandora Premium',
    [discountTypes.STUDENT]: 'Pandora Premium Student',
    [discountTypes.MILITARY]: 'Pandora Premium Military',
  },
  [tiers.PANDORA_FAMILY]: {
    [discountTypes.NONE]: 'Pandora Premium Family',
  },
});
// END of copied constants

export const TierGlyph = Object.freeze({
  [tiers.AD_SUPPORTED]: LogoPandoraIcon,
  [tiers.PANDORA_PLUS]: LogoPlusIcon,
  [tiers.PANDORA_PREMIUM]: LogoPremiumIcon,
  [tiers.PANDORA_FAMILY]: LogoPremiumIcon,
});

export const ModifierGlyph = Object.freeze({
  [tiers.PANDORA_FAMILY]: LogoFamilyIcon,
  [discountTypes.STUDENT]: LogoStudentIcon,
  [discountTypes.MILITARY]: LogoMilitaryIcon,
});

export const RuleIcon = LogoRuleIcon;
